import { useAuth } from '@/contexts/AuthContext';
import { AppShell } from '@/components/layout/AppShell';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Bell, Lock } from 'lucide-react';

const SettingsPage = () => {
  const { user } = useAuth();

  return (
    <AppShell>
      <div className="max-w-2xl mx-auto space-y-6" data-testid="settings-page">
        <div>
          <h1 className="font-serif text-3xl font-bold text-gray-900">
            Einstellungen
          </h1>
          <p className="text-gray-500 mt-1">
            Passen Sie ForestHub an Ihre Bedürfnisse an
          </p>
        </div>

        {/* Notifications (Placeholder) */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Bell className="h-5 w-5" />
              Benachrichtigungen
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-500">
              Benachrichtigungseinstellungen werden in einer zukünftigen Version verfügbar sein.
            </p>
          </CardContent>
        </Card>

        {/* Account Info */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Lock className="h-5 w-5" />
              Konto
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label className="text-gray-500">E-Mail</Label>
              <p className="font-medium">{user?.email}</p>
            </div>
            <div>
              <Label className="text-gray-500">Rolle</Label>
              <p className="font-medium">
                {user?.role === 'waldbesitzer' ? 'Waldbesitzer' : 'Forstdienstleister'}
              </p>
            </div>
            <div>
              <Label className="text-gray-500">Mitglied seit</Label>
              <p className="font-medium">
                {user?.created_at 
                  ? new Date(user.created_at).toLocaleDateString('de-DE')
                  : '–'}
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
};

export default SettingsPage;
